import { Component } from "react";

// Minimal React error boundary. A crash inside its subtree is contained here so it can
// never tear down the parent React root (the embedded sections are single legacy roots,
// so an uncaught descendant error would otherwise unmount the WHOLE section).
// Renders `fallback` (default: nothing) on error. Pass a changing `resetKey` to clear the
// error state when the caller wants to retry (e.g. reopening a modal for a new item).
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.warn("ErrorBoundary caught an error:", error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) return this.props.fallback ?? null;
    return this.props.children;
  }
}
